import { render, staticRenderFns } from "./404.vue?vue&type=template&id=0f42102e&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=0f42102e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42102e",
  null
  
)

export default component.exports